import { Navigate, Route } from "react-router-dom";
import { lazy } from "react";
import { PATHS } from "../../../constants/paths";

const DataPage = lazy(() => import("../Data"));
const ExportTab = lazy(() => import("../tabs/ExportTab"));
const InterfonTab = lazy(() => import("../tabs/InterfonTab"));
const CustomerApiTab = lazy(() => import("../tabs/CustomerApiTab"));

const useDataRoutes = () => (
  <Route path={`${PATHS.Data.Path}`} element={<DataPage />}>
    <Route path={PATHS.Data.Tabs.Export.Path} element={<ExportTab />} />
    <Route path={PATHS.Data.Tabs.Interfon.Path} element={<InterfonTab />} />
    <Route
      path={PATHS.Data.Tabs.CustomerApi.Path}
      element={<CustomerApiTab />}
    />
    <Route
      path={PATHS.Data.Tabs.CustomerApi.Path}
      element={<CustomerApiTab />}
    />
    <Route
      index
      element={<Navigate replace to={PATHS.Data.Tabs.Export.Path} />}
    />
  </Route>
);

export { useDataRoutes };
